import { PackI, PackName } from '../../../interfaces/cycle.interface';

const packPrecedence: PackName[] = [
  PackName.ManagersSelection,
  PackName.SelfSelection,
  PackName.SelfAssessment,
  PackName.Assessment,
];

export default function (a: PackI, b: PackI): number {
  const iA = packPrecedence.indexOf(a.name);
  const iB = packPrecedence.indexOf(b.name);
  return iA - iB;
}
